import { render, staticRenderFns } from "./addAttnGroup.vue?vue&type=template&id=60c865fc&"
import script from "./addAttnGroup.vue?vue&type=script&lang=js&"
export * from "./addAttnGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports